<template>
	<base-button :class="['button-secret', { 'button-secret--on': secretMode }]" @click="buttonHandler">
		<svg-icon class="button-secret-icon" name="secret" :size="16" />
	</base-button>
</template>

<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import { useThreadStore } from '@/stores/thread'
import { computed } from 'vue'

const emit = defineEmits<{
	buttonSecretHandler: []
}>()

const threadStore = useThreadStore()

const secretMode = computed(() => threadStore.secretMode)

function buttonHandler() {
	emit('buttonSecretHandler')
}
</script>

<style lang="scss" scoped>
.button-secret {
	color: var(--text-primary);
	padding: 4px 4px;
	border-radius: var(--radius-md);
	border: none;
	background-color: var(--background-secondary);
	transition: $transition-color;
	cursor: pointer;
	@include flex-center;
	font: var(--font-label);
	@media (min-width: $screen-mobile) {
		&:hover {
			color: var(--control-hover);
		}
		&:active {
			color: var(--text-primary);
		}
	}

	&--on {
		color: var(--control-active);
		&:hover {
			color: var(--control-active);
		}
		&:active {
			color: var(--control-active);
		}
	}
}
</style>
